var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_453_3299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8694 5.96474C21.7448 5.52037 21.5022 5.11805 21.1672 4.80057C20.8228 4.47332 20.4007 4.23924 19.9407 4.1204C18.2192 3.66665 11.3222 3.66666 11.3222 3.66666C8.44693 3.63394 5.57236 3.77782 2.71471 4.09749C2.25472 4.2251 1.8334 4.46442 1.48821 4.79415C1.14905 5.12049 0.903381 5.5229 0.775048 5.96382C0.466766 7.62459 0.316982 9.31089 0.327714 11C0.316714 12.6876 0.466131 14.3733 0.775048 16.0362C0.900631 16.4752 1.14538 16.8758 1.48546 17.1994C1.82555 17.523 2.24905 17.7567 2.71471 17.8805C4.45913 18.3333 11.3222 18.3333 11.3222 18.3333C14.2012 18.3661 17.0794 18.2222 19.9407 17.9025C20.4007 17.7837 20.8228 17.5496 21.1672 17.2223C21.5064 16.8987 21.7475 16.4963 21.8685 16.0582C22.1848 14.398 22.3386 12.711 22.3277 11.0211C22.3515 9.32396 22.1979 7.629 21.8694 5.96382V5.96474ZM9.12955 14.1387V7.86224L14.8679 11.0009L9.12955 14.1387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_453_3299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.328125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.74b605894b1a89bd7a5207af877827fe.svg";
export { ForwardRef as ReactComponent };